// @generated by protoc-gen-es v1.10.0
// @generated from file penumbra/core/component/sct/v1/sct.proto (package penumbra.core.component.sct.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { MerkleRoot, StateCommitment } from "../../../../crypto/tct/v1/tct_pb.js";

/**
 * Configuration data for the SCT component.
 *
 * @generated from message penumbra.core.component.sct.v1.SctParameters
 */
export const SctParameters = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.sct.v1.SctParameters",
  () => [
    { no: 1, name: "epoch_duration", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * Sct-specific genesis content.
 *
 * @generated from message penumbra.core.component.sct.v1.GenesisContent
 */
export const GenesisContent = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.sct.v1.GenesisContent",
  () => [
    { no: 1, name: "sct_params", kind: "message", T: SctParameters },
  ],
);

/**
 * An epoch is a sequentially numbered collection of contiguous blocks.
 *
 * @generated from message penumbra.core.component.sct.v1.Epoch
 */
export const Epoch = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.sct.v1.Epoch",
  () => [
    { no: 1, name: "index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "start_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * Metadata describing the source of a commitment in the state commitment tree.
 *
 * This message allows clients to track provenance of state commitments, and to
 * decide whether or not to download block data.
 *
 * @generated from message penumbra.core.component.sct.v1.CommitmentSource
 */
export const CommitmentSource = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.sct.v1.CommitmentSource",
  () => [
    { no: 1, name: "transaction", kind: "message", T: CommitmentSource_Transaction, oneof: "source" },
    { no: 2, name: "ics_20_transfer", kind: "message", T: CommitmentSource_Ics20Transfer, oneof: "source" },
    { no: 20, name: "funding_stream_reward", kind: "message", T: CommitmentSource_FundingStreamReward, oneof: "source" },
    { no: 30, name: "community_pool_output", kind: "message", T: CommitmentSource_CommunityPoolOutput, oneof: "source" },
    { no: 40, name: "genesis", kind: "message", T: CommitmentSource_Genesis, oneof: "source" },
  ],
);

/**
 * The state commitment was included in the genesis state.
 *
 * @generated from message penumbra.core.component.sct.v1.CommitmentSource.Genesis
 */
export const CommitmentSource_Genesis = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.sct.v1.CommitmentSource.Genesis",
  [],
  {localName: "CommitmentSource_Genesis"},
);

/**
 * The commitment was created by a transaction.
 *
 * When included in a `CompactBlock` via a `StatePayload`, the transaction source is "dehydrated"
 * by stripping the `id` field and putting empty bytes in its place.  When clients perform extended
 * transaction fetch, they should match up transaction hashes to "rehydrate" the source info.
 *
 * @generated from message penumbra.core.component.sct.v1.CommitmentSource.Transaction
 */
export const CommitmentSource_Transaction = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.sct.v1.CommitmentSource.Transaction",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
  {localName: "CommitmentSource_Transaction"},
);

/**
 * The commitment was created through a validator's funding stream.
 *
 * @generated from message penumbra.core.component.sct.v1.CommitmentSource.FundingStreamReward
 */
export const CommitmentSource_FundingStreamReward = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.sct.v1.CommitmentSource.FundingStreamReward",
  () => [
    { no: 1, name: "epoch_index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
  {localName: "CommitmentSource_FundingStreamReward"},
);

/**
 * The commitment was created through a `CommunityPoolOutput` in a governance-initated transaction.
 *
 * @generated from message penumbra.core.component.sct.v1.CommitmentSource.CommunityPoolOutput
 */
export const CommitmentSource_CommunityPoolOutput = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.sct.v1.CommitmentSource.CommunityPoolOutput",
  [],
  {localName: "CommitmentSource_CommunityPoolOutput"},
);

/**
 * The commitment was created by an inbound ICS20 transfer.
 *
 * @generated from message penumbra.core.component.sct.v1.CommitmentSource.Ics20Transfer
 */
export const CommitmentSource_Ics20Transfer = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.sct.v1.CommitmentSource.Ics20Transfer",
  () => [
    { no: 1, name: "packet_seq", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "sender", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "CommitmentSource_Ics20Transfer"},
);

/**
 * @generated from message penumbra.core.component.sct.v1.Nullifier
 */
export const Nullifier = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.sct.v1.Nullifier",
  () => [
    { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * Records information about what transaction spent a nullifier.
 *
 * @generated from message penumbra.core.component.sct.v1.NullificationInfo
 */
export const NullificationInfo = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.sct.v1.NullificationInfo",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "spend_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * Event recording a new commitment added to the SCT.
 *
 * @generated from message penumbra.core.component.sct.v1.EventCommitment
 */
export const EventCommitment = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.sct.v1.EventCommitment",
  () => [
    { no: 1, name: "commitment", kind: "message", T: StateCommitment },
    { no: 2, name: "position", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "source", kind: "message", T: CommitmentSource },
  ],
);

/**
 * Event recording an SCT anchor (global root).
 *
 * @generated from message penumbra.core.component.sct.v1.EventAnchor
 */
export const EventAnchor = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.sct.v1.EventAnchor",
  () => [
    { no: 1, name: "anchor", kind: "message", T: MerkleRoot },
    { no: 2, name: "height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * Event recording an SCT epoch root.
 *
 * @generated from message penumbra.core.component.sct.v1.EventEpochRoot
 */
export const EventEpochRoot = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.sct.v1.EventEpochRoot",
  () => [
    { no: 1, name: "root", kind: "message", T: MerkleRoot },
    { no: 2, name: "index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * Event recording an SCT block root.
 *
 * @generated from message penumbra.core.component.sct.v1.EventBlockRoot
 */
export const EventBlockRoot = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.sct.v1.EventBlockRoot",
  () => [
    { no: 1, name: "root", kind: "message", T: MerkleRoot },
    { no: 2, name: "height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message penumbra.core.component.sct.v1.EpochByHeightRequest
 */
export const EpochByHeightRequest = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.sct.v1.EpochByHeightRequest",
  () => [
    { no: 1, name: "height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message penumbra.core.component.sct.v1.EpochByHeightResponse
 */
export const EpochByHeightResponse = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.sct.v1.EpochByHeightResponse",
  () => [
    { no: 1, name: "epoch", kind: "message", T: Epoch },
  ],
);

/**
 * @generated from message penumbra.core.component.sct.v1.AnchorByHeightRequest
 */
export const AnchorByHeightRequest = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.sct.v1.AnchorByHeightRequest",
  () => [
    { no: 1, name: "height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message penumbra.core.component.sct.v1.AnchorByHeightResponse
 */
export const AnchorByHeightResponse = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.sct.v1.AnchorByHeightResponse",
  () => [
    { no: 1, name: "anchor", kind: "message", T: MerkleRoot },
  ],
);

/**
 * @generated from message penumbra.core.component.sct.v1.TimestampByHeightRequest
 */
export const TimestampByHeightRequest = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.sct.v1.TimestampByHeightRequest",
  () => [
    { no: 1, name: "height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * @generated from message penumbra.core.component.sct.v1.TimestampByHeightResponse
 */
export const TimestampByHeightResponse = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.component.sct.v1.TimestampByHeightResponse",
  () => [
    { no: 1, name: "timestamp", kind: "message", T: Timestamp },
  ],
);

